// extracted by mini-css-extract-plugin
export default {"sideMenu":"layout_sideMenu__LkS6p","border-bottom":"layout_border-bottom__061Dy","main":"layout_main__NO4Ok"};